export * from './tabs-cart-modal.component'
